import React, { useState, useEffect } from "react";
import Navbar from "../../components/Navbar/Navbar";
import { Breadcrumb } from "antd";
import { DoubleRightOutlined, DownloadOutlined } from "@ant-design/icons";
import ShimmerLoader from "../../loading";
import "../../styles.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { routes } from "../../Routes";
import {
    getExpiryProducts,
} from "../../API  Functions/SessionHistoryFunctions";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import { toast } from "react-toastify";
import i18next from "i18next";
import moment from "moment";
import ProductExpiryTable from "./Tables/ProductExpiryTable";
import ExportCasInOutReportModal from "../../app/SessionHistory/ExportCasInOutReportModal";
import dayjs from "dayjs";
import FutureDateFilter from "../ui/FutureDateFilter";
import { checkPermission } from "../../Utils/permissionHelper";

const ProductExpiry = () => {
    const { t } = useTranslation();
    const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
    const company_id = useSelector(
        (state) => state?.login?.user?.result?.company_id
    );

    const isGinne = useSelector(
        (state) => state?.geneLoginReducer?.isGinneLogin
    );
    const allStores = useSelector(
        (state) => state?.storeReducer?.selectedStore?.is_select_all_store
    );

    const [loading, setloading] = useState(false);
    const [expiryData, setExpiryData] = useState([]);
    const [currentLimit, setCurrentLimit] = useState(50);
    const [currentOffset, setCurrentOffset] = useState(0);
    const [exportModalOpen, setExportModalOpen] = useState(false);

    const today = dayjs();
    const formatToday = today.format("YYYY-MM-DD");
    const startofMonth = today.startOf("month").format("YYYY-MM-DD");
    const [startDate, setStartDate] = useState(startofMonth);
    const [endDate, setEndDate] = useState(formatToday);
    const [selectedRange, setSelectedRange] = useState("thisMonth");

    const GetExpiryData = async (limit = currentLimit, offset = currentOffset) => {
        setloading(true);
        const payload = {
            company_id,
            start_date: startDate,
            end_date: endDate,
            offset,
            limit,
            lang: i18next.language === "ar" ? "ar_001" : "en_US",
        };
        try {
            const res1 = await getExpiryProducts(payload);
            if (res1?.result?.status_code === 200) {
                setExpiryData(res1?.result?.expiry_products || []);
            } else {
                setExpiryData([]);
            }
        } catch (error) {
            console.error("Error fetching expiry data:", error);
        } finally {
            setloading(false);
        }
    };

    // 🔹 Call only once when startDate / endDate / pagination change
    useEffect(() => {
        GetExpiryData(currentLimit, currentOffset);
    }, [startDate, endDate, currentLimit, currentOffset]);

    const handleExport = async (dates) => {
        let payload = {
            lang: i18next.language === "ar" ? "ar_001" : "en_US",
            start_date: dates?.startDate,
            end_date: dates?.endDate,
            company_id: company_id,
        };
        const response = await axiosInstance.post(URLS.GET_EXPIRY_PRODUCT_EXCEL, payload);
        if (response?.data?.result?.status === "success") {
            setExportModalOpen(false);
            downloadFile(response?.data?.result?.file);
        } else {
            toast.error(response?.data?.result.status);
        }
    };

    const downloadFile = (base64Data) => {
        try {
            if (!base64Data || typeof base64Data !== "string") {
                alert("No valid file data available for download");
                return;
            }
            let cleanBase64 = base64Data
                .trim()
                .replace(/^data:[\w/+-]+;base64,/, "")
                .replace(/^["']|["']$/g, "")
                .replace(/\s/g, "");

            const padLength = 4 - (cleanBase64.length % 4);
            if (padLength < 4) cleanBase64 += "=".repeat(padLength);

            let binaryString = atob(cleanBase64);
            const bytes = new Uint8Array(binaryString.length);
            for (let i = 0; i < binaryString.length; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }

            const header = new Uint8Array(bytes.buffer, 0, 8);
            let mimeType = "application/octet-stream";
            let fileExtension = "bin";

            if (header[0] === 0x50 && header[1] === 0x4b) {
                mimeType =
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                fileExtension = "xlsx";
            } else if (
                header[0] === 0xd0 &&
                header[1] === 0xcf &&
                header[2] === 0x11 &&
                header[3] === 0xe0
            ) {
                mimeType = "application/vnd.ms-excel";
                fileExtension = "xls";
            }

            const blob = new Blob([bytes], { type: mimeType });
            const timestamp = moment().format("YYYY-MM-DD_HH.mm.ss");
            const filename = `${t("expiry_products")}_${timestamp}.${fileExtension}`;
            const url = URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            setTimeout(() => {
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            }, 100);
        } catch (error) {
            console.error("File download failed:", error);
            alert(`Download failed: ${error.message || "Unknown error"}`);
        }
    };

    return (
        <>
            <div className="w-full flex flex-col md:h-full pb-2 overflow-y-auto bg-[#F6F7F9]">
                <Navbar heading="Product Expiry" />
                <div className="flex-grow overflow-y-auto custom-scrollbar overflow-hidden ms-3">
                    <div className="font-extrabold">
                        {/* <Breadcrumb
                            separator={<DoubleRightOutlined />}
                            items={[
                                {
                                    title: (
                                        <Link to={routes.inventory.root}>
                                            {t("inventory")}
                                        </Link>
                                    ),
                                    key: "inventory",
                                },
                                { title: t("Product Expiry") },
                            ]}
                            className="relative mt-3 font-semibold"
                        /> */}
                    </div>

                    <div className="mt-3 px-4">
                        <div className="flex justify-between items-center">
                            <FutureDateFilter
                                setSelectedRange={setSelectedRange}
                                selectedRange={selectedRange}
                                SubmitFilter={(start, end) => {
                                    setStartDate(start);
                                    setEndDate(end);
                                }}
                            />


                            <button
                                className="w-48 h-10 bg-primaryBlue text-white text-sm font-semibold rounded-lg flex items-center justify-center gap-2"
                                // onClick={() => setExportModalOpen(true)}
                                // onClick={() => {
                                //     if (checkPermission("/inventory/ProductExpiry", isGinne)) {
                                //         setExportModalOpen(true);
                                //     }
                                // }}

                                onClick={() => {
                                    if (allStores) {
                                        // Open the modal immediately if allStores is true
                                        setExportModalOpen(true);
                                    } else {
                                        // Check permission for the specific path and open the modal if permission is granted
                                        if (checkPermission("/inventory/ProductExpiry", isGinne)) {
                                            setExportModalOpen(true);
                                        } else {
                                            // Optionally handle permission denial (log or alert)
                                            console.log("Permission denied for /inventory/ProductExpiry");
                                        }
                                    }
                                }}
                            >
                                <DownloadOutlined style={{ fontSize: "1.5em" }} />
                                <span>{t("Download in Excel")}</span>
                            </button>
                        </div>

                        {loading ? (
                            <ShimmerLoader />
                        ) : (
                            <ProductExpiryTable
                                additionalData={expiryData}
                                pagination={(values) => {
                                    setCurrentLimit(values.limit);
                                    setCurrentOffset(values.offset);
                                    // GetExpiryData(values.limit, values.offset);
                                }}
                            />
                        )}
                    </div>
                </div>
            </div>

            {exportModalOpen && (
                <ExportCasInOutReportModal
                    heading={t("Download Product Expiry Data")}
                    isOpen={exportModalOpen}
                    onClose={() => setExportModalOpen(false)}
                    onExport={(dates) => handleExport(dates)}
                    showFutureDates={true}
                />
            )}
        </>
    );
};

export default ProductExpiry;
